import type { ReactElement } from 'react';
import { useState } from 'react';

import Title from '@/components/atoms/Title';

import { CaretIcon } from './CaretIcon';
import {
  AccordionContent,
  AccordionContentWrapper,
  AccordionHeader,
  AccordionItem,
  AccordionText,
  AccordionWrapper,
  Wrapper,
} from './FAQ.styled';

const faqData = [
  {
    question: 'Czym się różni ten przewodnik od innych dostępnych na rynku?',
    answer:
      'Zawiera treści przygotowane na bazie doświadczenia i esencję tego, co chcesz wiedzieć przed podróżą. Znajdziesz w nim sprawdzone rekomendacje, ostrzeżenia na bazie moich przygód, praktyczne informacje, które pomogą Ci zaplanować samodzielnie podróż od A do Z i zaoszczędzić wszędzie tam, gdzie to możliwe. Wraz z przewodnikiem dostajesz moje autorskie, interaktywne narzędzia, które pomagają w planowaniu podróży i poruszaniu się na miejscu.',
  },
  {
    question: 'W jakim formacie dostępny jest przewodnik?',
    answer:
      'Przewodnik jest dostępny w wersji cyfrowej (PDF), a Planer Podróży jest w formacie obsługiwanym przez Microsoft Excel i Google Sheets. Wszystkie pliki możesz pobrać od razu po zakupie.',
  },
  {
    question: 'Czy przewodnik jest odpowiedni dla rodzin z dziećmi?',
    answer:
      'Jak najbardziej! W przewodniku znajdziesz mnóstwo porad, które mogą się przydać podczas podróży z dzieckiem, a także atrakcje, z których chętnie skorzystają najmłodsi.',
  },
  {
    question:
      'Czy przewodnik zawiera informacje o lokalnych restauracjach i kuchni?',
    answer:
      'Tak, w przewodniku jest część poświęcona kuchni, w której czytelnik może poznać panujące na wyspie zwyczaje, najpopularniejsze dania oraz polecane przeze mnie restauracje (również z menu dla wegetarian).',
  },
  {
    question: 'Czy przewodnik zawiera mapy?',
    answer:
      'Tak, wraz z przewodnikiem otrzymasz dostęp do moich prywatnych map, na których znajdziesz 170 miejsc do odwiedzenia, w tym: punkty widokowe, plaże, baseny naturalne, przykładowe szlaki turystyczne, muzea, parki i inne atrakcje warte odwiedzenia. W przewodniku znajdziesz też przykładowe trasy trekkingowe, a wraz z nimi linki do map, które posłużą Ci jako nawigacja nawet offline.',
  },
  {
    question: 'Czy mogę zwrócić przewodnik po zakupie?',
    answer:
      'Niestety nie ma możliwości zwrotu zakupionego przewodnika, ponieważ w momencie zakupu wyrażasz zgodę na natychmiastowe rozpoczęcie realizacji sprzedaży (pobranie pliku zaraz po zakupie) jednocześnie tracąc prawo do odstąpienia od umowy.',
  },
  {
    question: 'Czy mogę podarować przewodnik jako prezent?',
    answer:
      'Tak, możesz to zrobić na dwa sposoby: przy zakupie podać adres e-mail osoby, której chcesz go podarować lub zamówić specjalny kod do pobrania, który przekażesz tej osobie, aby osobiście dokonała zakupu w sklepie. Jeśli chcesz otrzymać kod prezentowy – napisz do mnie na adres: kontakt@foxparadox.pl lub poprzez formularz kontaktowy w zakładce „Kontakt”.',
  },
  {
    question: 'Czy przewodnik jest aktualny?',
    answer:
      'Przewodnik zawiera najświeższe informacje i będzie cyklicznie aktualizowany.',
  },
  {
    question: 'Jak mogę się skontaktować w razie dodatkowych pytań?',
    answer:
      'Jeśli masz dodatkowe pytania, napisz do mnie na Instagramie lub poprzez formularz kontaktowy w zakładce „Kontakt”. Odpowiem najszybciej, jak to możliwe.',
  },
];

export const FAQ = (): ReactElement => {
  const [openIndex, setOpenIndex] = useState<number | null>(-1);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Wrapper>
      <Title>Najczęściej zadawane pytania</Title>
      <AccordionWrapper>
        {faqData.map((faq, index) => (
          <AccordionItem key={index}>
            <AccordionHeader
              isOpen={openIndex === index}
              onClick={() => toggleAccordion(index)}
            >
              {faq.question}
              <CaretIcon size={24} />
            </AccordionHeader>
            <AccordionContentWrapper isOpen={openIndex === index}>
              <AccordionContent>
                <AccordionText>{faq.answer}</AccordionText>
              </AccordionContent>
            </AccordionContentWrapper>
          </AccordionItem>
        ))}
      </AccordionWrapper>
    </Wrapper>
  );
};
